import { useEffect } from "react";
import CustomButton from "../../../components/CustomButton";
import avatar from "../../../../assets/img/noAvatar.png";
import { useSelector, useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { TalentJobChange } from "../../../api/types.gen";
import { fetchCompanyTalentHasChangedJob, setOpenDetailTalentPanel } from "../../../reducers/companyHome";
import { formatDateTimeExcludeYear, formatDate, formatName, getAge, convertToFullDate, getAgeByYearMonthDay} from "../../../utils/format";
import CustomToast from "components/CustomToast";
import {useSnackbar} from "notistack";
import { MESSAGE_SEND_FROM, TALENT_ACTIVITY_TYPE } from "../../../constants/index";

import {
  setChatSelected, setActionItems, setGlobalFilterString,
  setIsChatting,
  setIsScout,
  setJobSelected, setMessages,
  setTalentSelected,
  getDetailTalentChat,
  setIsNewChatFormOtherScreen, setMessageSendFrom
} from "reducers/chatMessage";
import {
  setSelectedTalent, togglePanel, setFilterQuery,
  getDetailTalent, setActionStatus, setSortBy, setGlobalSearchTalentFormData,
  setIsClickSearch, setCancelTalentStatus, setTalentTagsSelected
} from "reducers/companyTalent";
type talentHasChangedJobInfoExcerptProps = {
  idx: number;
  talent: TalentJobChange,
  openTalentDetailPanel: (id: number) => void
}

const TalentHasChangedJob = ({ idx, talent, openTalentDetailPanel}: talentHasChangedJobInfoExcerptProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const goToChat = (item: any) => {
    dispatch(setTalentSelected(item));
    dispatch(getDetailTalentChat({id: item.talent_id}));
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(true));
    dispatch(setIsScout(true));
    dispatch(setChatSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    dispatch(setActionItems([]));
    dispatch(setMessageSendFrom(MESSAGE_SEND_FROM.HOME));
    dispatch(setGlobalFilterString(item.talent_id));
    navigate('/company/message', { state: { isFromHome: true } } )
  }

  return (
    <div key={idx}>
  <p className="alu-text-base-1 text-sm mb-[0.125rem]">
	{formatDateTimeExcludeYear(talent.last_activity_at)}
  </p>
  <div
	key={idx}
	className="flex items-center justify-between gap-6"
  >
	<div className="flex items-center gap-4 flex-1">
	  <img
		src={talent.avatar ? talent.avatar : avatar}
		alt={`talent-${idx}`}
		className="w-10 h-10 rounded-full object-cover cursor-pointer"
    onClick={() => openTalentDetailPanel(talent.talent_id)}
    />
	  <div className="flex-1 text-sm">
		<p
      onClick={() => openTalentDetailPanel(talent.talent_id)}
		  className="hover:text-[#FF861A] w-[90%] alu-text-base-2 font-bold cursor-pointer"
		>
      {talent?.last_activity_change_type && (
        talent?.last_activity_change_type == TALENT_ACTIVITY_TYPE.VIEW_JOB
        ? `${formatName(talent.first_name, talent.last_name)}さんが 求人情報を3件以上閲覧しました`
        : (
          talent?.last_activity_change_type == TALENT_ACTIVITY_TYPE.WORK_PARTTIME
          ? `${formatName(talent.first_name, talent.last_name)} さんが 副業意欲を「${talent.last_activity_status_label}」に変更しています`
          : `${formatName(talent.first_name, talent.last_name)} さんが 転職意欲を「${talent.last_activity_status_label}」に変更しています`
        )
      )}
		</p>
		<div className="flex items-center gap-4 text-sm alu-text-base-1">
		  <p>{getAgeByYearMonthDay(talent?.birth_year, talent?.birth_month, talent?.birth_day)} {talent.current_profession}</p>
		  {talent.leave_company_year && <p> {convertToFullDate(talent?.leave_company_year, talent?.leave_company_month, talent?.leave_company_day, true)} 退職</p>}
		</div>
	  </div>
	</div>
  {talent?.is_active && 
	<CustomButton customStyle="shrink-0" size="md"
		onClick={() => goToChat(talent)}
	>
	  スカウト
	</CustomButton>
  }
  </div>
</div>
  )
}

type talentNewRegistrationExcerptProps = {
  idx: number;
  talent: TalentJobChange
  openTalentDetailPanel: (id: number) => void
}

const TalentNewRegistration = ({idx, talent, openTalentDetailPanel}: talentNewRegistrationExcerptProps) => {
  return (
    <div key={idx}>
      <p className="alu-text-base-1 text-sm mb-[0.125rem]">
        {formatDateTimeExcludeYear(talent.created_at)}
      </p>
      <div
        className="flex items-center justify-between gap-6"
      >
        <div className="flex items-center gap-2 flex-1">
          <img
            onClick={() => openTalentDetailPanel(talent.talent_id)}
            src={talent.avatar ? talent.avatar : avatar}
            alt={`talent-${idx}`}
            className="w-10 h-10 rounded-full object-cover cursor-pointer"
          />
          <div className="flex-1 text-sm">
            <p
              className="hover:text-[#FF861A] w-[90%] alu-text-base-2 font-bold line-clamp-1 cursor-pointer"
              onClick={() => openTalentDetailPanel(talent.talent_id)}
            >
              {formatName(talent.first_name, talent.last_name)}
            </p>
            <div className="flex items-center gap-4 text-sm alu-text-base-1">
              <p>{getAgeByYearMonthDay(talent?.birth_year, talent?.birth_month, talent?.birth_day)} {talent.current_profession}</p>
              {talent.leave_company_year && <p>{convertToFullDate(talent?.leave_company_year, talent?.leave_company_month, talent?.leave_company_day, true)} 退職</p>}
            </div>
          </div>
        </div>
        <button className="shrink-0"
          onClick={() => openTalentDetailPanel(talent.talent_id)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <g clipPath="url(#clip0_10454_83977)">
              <path
                d="M9.99984 6.98438L8.58984 8.39437L13.1698 12.9844L8.58984 17.5744L9.99984 18.9844L15.9998 12.9844L9.99984 6.98438Z"
                fill="#808080"
              />
            </g>
            <defs>
              <clipPath id="clip0_10454_83977">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.984375)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  )
}
type EmptyProps = {
  msg: string
}
const CompanyHomeTalentEmpty = (data: EmptyProps) => {
  return (
    <div className="flex items-center justify-center" style={{ height: "300px" }}>
      <p className="text-center text-sm alu-text-base-2">
        {data.msg}
      </p>
    </div>
  )
}

const CompanyHomeTalent = () => {
  const navigate = useNavigate();
  const rankAOnly = useSelector((state: any) => state.companyHome.rankAOnly);
  const isTalentSummaryLoading = useSelector((state: any) => state.companyHome.isTalentSummaryLoading);
  const talentHasChangedJob =  useSelector((state: any) => state.companyHome.talentHasChangedJob);
  const talentNewRegistrations = useSelector((state: any) => state.companyHome.talentNewRegistrations);
  const isOpenDetailTalentPanel = useSelector((state: any) => state.companyHome.isOpenDetailTalentPanel);
  const selectedTypeOfTalent = useSelector((state: any) => state.companyHome.selectedTypeOfTalent);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { actionStatus, actionName, message, isSuccess, initSearchTalentForm,
    cancelTalentStatus } = useSelector((state: any) => state.companyTalent);

  useEffect(() => {
    dispatch(setOpenDetailTalentPanel(false));
  }, [])

  useEffect(() => {
    dispatch(fetchCompanyTalentHasChangedJob({ 
      rankAonly: rankAOnly ? 1 : 0,
      talentType: selectedTypeOfTalent?.value,
    }));
  }, [rankAOnly, selectedTypeOfTalent])
  const goToTalentList = () => {
    dispatch(setGlobalSearchTalentFormData({
      ...initSearchTalentForm,
      type: selectedTypeOfTalent && selectedTypeOfTalent?.value ? [selectedTypeOfTalent] : [],
      recruitment_rank: rankAOnly ? { name: 'A', id: 'a' } : null,
    }));
    dispatch(setIsClickSearch(false));
    dispatch(setSortBy("-created_at"));
    navigate('/company/talent', { state: { isFromDetail: false } });
  }
  const goToTalentDetail = (item: any) => {
    dispatch(setSelectedTalent({}));
    dispatch(setTalentTagsSelected([]));
    if (!isOpenDetailTalentPanel) {
      dispatch(setOpenDetailTalentPanel(true));
    }
    dispatch(getDetailTalent({ id: item.id }));
  }

  const showToast = (title: any) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={isSuccess ? "success" : "error"} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };
  // Show toast
  useEffect(() => {
    if (actionStatus === 'fulfilled' && actionName === 'updateTalentInfo') {
      dispatch(fetchCompanyTalentHasChangedJob({ 
        rankAonly: rankAOnly ? 1 : 0,
        talentType: selectedTypeOfTalent?.value,
      }));
    }
  }, [actionStatus, actionName]);

  useEffect(() => {
    if (cancelTalentStatus === 'fulfilled') {
      dispatch(fetchCompanyTalentHasChangedJob({ 
        rankAonly: rankAOnly ? 1 : 0,
        talentType: selectedTypeOfTalent?.value,
      }));
      dispatch(setCancelTalentStatus("idle"));
    }
  }, [cancelTalentStatus]);

  return (
    <div className="mb-6 flex gap-6">
      <div className="w-[60%]">
        <div className="mb-4 flex items-center justify-between">
          <h5 className="text-xl alu-text-base-2 font-bold">
            最近転職フラグがついた人
          </h5>
          <CustomButton
            variant="text"
            customStyle="!hidden"
          >
            すべてみる
          </CustomButton>
        </div>

        <div className="rounded-2xl bg-white p-6 flex flex-col gap-2 alu-section-box-shadow">
          {
          (!isTalentSummaryLoading && talentHasChangedJob.length == 0) ?
            <CompanyHomeTalentEmpty msg="まだ投稿がありません" />
            :
          talentHasChangedJob
            .map((item: TalentJobChange, idx: number) => (
              <TalentHasChangedJob key={idx} idx={idx} talent={item} openTalentDetailPanel={() => goToTalentDetail(item)} />
            ))}
        </div>
      </div>

      <div className="w-[40%]">
        <div className="mb-4 flex items-center justify-between">
          <h5 className="text-xl alu-text-base-2 font-bold">
            最近登録したタレント
          </h5>
          <CustomButton
            variant="text"
            onClick={() => goToTalentList()}
          >
            すべてみる
          </CustomButton>
        </div>

        <div className="rounded-2xl bg-white p-6 flex flex-col gap-2 alu-section-box-shadow">
          {
          (!isTalentSummaryLoading && talentNewRegistrations.length == 0) ?
            <CompanyHomeTalentEmpty msg="まだ投稿がありません" /> 
          :
          talentNewRegistrations
            .map((item: TalentJobChange, idx:number) => (
              <TalentNewRegistration key={idx} idx={idx} talent={item} openTalentDetailPanel={() => goToTalentDetail(item)} />
            ))}
        </div>
      </div>
    </div>
  );
}

export default CompanyHomeTalent;